export const TRAINING_EVENT_TYPES = {
  Logged: 'Logged',
  VideoRecorded: 'VideoRecorded'
};